
<workflow-no-access [workflowTargetInfo]="workflowTargetInfo"></workflow-no-access>
<div class="container" [hidden]="!workflowTargetInfo.correctRole" [ngClass]="{'general-disabled':project.isMigrationActive}">
  <error [error]="error"></error>
  <div class="row step-description-block">
    <div class="col">
      <div class="float-left">
        <p>Optional: add a "friendly name" and "preconfiguration service number" to each device solution.</p>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col pb-2">
      <list-controls [search]="devices.searchText" [limit]="devices.pageSize" [page]="devices.currentPage" [numPages]="devices.maxPages" [totalCount]="devices.filteredLength" (onChange)="devices.onListControlsChange($event)">
        <button class="btn btn-primary" (click)="save()">Save</button>
      </list-controls>
    </div>
  </div>
  <form [formGroup]="devices.form">
    <div class="row">
      <div class="col pb-2" formArrayName="booleanFilters">
        <div class="form-group form-check" *ngFor="let filter of devices.booleanFilters; let i = index" [formGroupName]="i">
          <input class="form-check-input" type="checkbox" formControlName="value" autoLinkToLabel (change)="devices.booleanFilterChanged()">
          <label class="form-check-label">{{ filter.caption }}</label>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col" formArrayName="items">
        <div class="row" *ngFor="let device of devices.filtered" [formGroupName]="device.index">
          <div class="col">
            <div class="card-item">
              <div class="row">
                <div class="col-sm-7">
                  <property-container>
                    <property-item><strong><span class="badge badge-secondary mr-2" *ngIf="device.quicksilver">QS</span><span>
                          {{ device.type === 'accessory' ? 'Accessory - ' : '' }}{{ device.type === 'software' ? 'Software - ' : '' }}
                           {{ device.productDescription }}</span></strong></property-item>
                  </property-container>
                  <property-container>
                    <property-item>Device Key: {{ device.deviceKey }}</property-item>
                    <property-item>SKU: {{ device.productNumber }}</property-item>
                  </property-container>
                  <property-container>
                    <property-item>QTY: {{ device.stats.total | number: 0 }}</property-item>
                    <property-item [showIf]="(device.stats.available) &gt; 0">Available: {{ device.stats.available | number: 0 }}</property-item>
                    <property-item>Planned: {{ device.stats.planned | number: 0 }}</property-item>
                    <property-item>Ordered: {{ device.stats.ordered | number: 0 }}</property-item>
                    <property-item>Deployed: {{ device.stats.installed | number: 0 }}</property-item>
                  </property-container><br>
                  <div class="col-md-12" *ngIf="device.type === 'asset' &amp;&amp; device.bundledItems?.length" style="padding:0">
                    <h6>Bundled Accessories:</h6>
                    <div class="col-sm-12" *ngFor="let child of device.bundledItems">
                      <property-container>
                        <property-item>{{ child.productNumber }} {{ child.productDescription }}</property-item>
                      </property-container>
                    </div>
                  </div>
                </div>
                <div class="col-sm-5">
                  <div class="form-group">
                    <label>Preconfiguration Service Number:</label>
                    <input class="form-control" autoLinkToLabel type="text" formControlName="bundleNumber">
                    <validation-error-display [error]="error" field="bundleNumber" [index]="device.deviceKey"></validation-error-display>
                  </div>
                  <div class="form-group">
                    <label>Friendly Name:</label>
                    <input class="form-control" autoLinkToLabel type="text" formControlName="friendlyName">
                    <validation-error-display [error]="error" field="friendlyName" [index]="device.deviceKey"></validation-error-display>
                  </div>
                  <div class="form-group" *ngIf="device.type === 'asset'">
                    <label>Quantity deployed outside TMC:</label>
                    <input class="form-control" autoLinkToLabel type="number" formControlName="alreadyUsedQuantity">
                    <validation-error-display [error]="error" field="alreadyUsedQuantity" [index]="device.deviceKey"></validation-error-display>
                  </div>
                  <div class="form-group form-check">
                    <input class="form-check-input" type="checkbox" formControlName="disabled" autoLinkToLabel>
                    <label class="form-check-label">Disabled</label>
                    <validation-error-display [error]="error" field="disabled" [index]="device.deviceKey"></validation-error-display>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row" *ngIf="!devices.filtered?.length">
          <div class="col">
            <div class="card-item">
              <p class="text-center empty-table-message">There are no devices in the current view.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>